export function roundModulo10(num, round = Math.round) {
  if (Math.abs(num) < 99) return round(num / 10) * 10;
  else if (Math.abs(num) < 9999) return round(num / 100) * 100;
  else return round(num / 1000) * 1000;
}
